<template>
  <div id="ACD18" class="ACD18 text-NotoSansRegular mx-auto">
    <div class="banner">
      <div class="max-w-5xl mx-auto">
        <img src="~@/assets/images/ACD18/banner.png" class="object-contain max-w-full w-full hidden sm:block">
        <img src="~@/assets/images/ACD18/banner_m.jpg" class="object-contain max-w-full w-full sm:hidden">
      </div>
    </div>
    <!-- 4大特色 -->
    <div class="feature pb-24 relative">
      <div class="color-bar absolute w-full z-20"></div>
      <div class="hands max-w-5xl mx-auto flex justify-center items-center px-4">
        <div class="z-10">
          <img src="~@/assets/images/ACD18/hand.png" class="max-w-full h-auto ">
        </div>
        <div class="px-2 md:px-4">
          <img src="~@/assets/images/ACD18/tit.png" class="max-w-full h-auto">
        </div>
      </div>
      <div class="feature_imgs flex flex-wrap max-w-5xl mx-auto px-4">
        <div class="feature_imgs-item w-full md:w-1/2 p-4" v-for="(item, index) in features" :key="index">
          <img :src="item.img_url" class="object-contain">
          <div class="feature_imgs-item-text py-5 lg:py-3 md:flex justify-center">
            <h5 class="text-white text-center text-xl xl:text-2xl tracking-wider"><span>{{ item.title }}</span></h5>
            <span class="hidden md:block">&ensp;</span>
            <h5 class="text-white text-center text-xl xl:text-2xl tracking-wider"><span>{{ item.title2 }}</span></h5>
          </div>
        </div>
      </div>
    </div>
    <!-- 雜誌介紹 -->
    <div class="introduction relative min-h-screen">
      <div class="introduction-title absolute">
        <img src="~@/assets/images/ACD18/tit2.png" class="object-contain">
      </div>
      <div class="introduction-items max-w-5xl mx-auto flex flex-wrap pt-10 px-4">
        <div class="introduction-item w-full lg:w-1/2 p-2 py-4 md:p-4 flex flex-col" v-for="(item, index) in introduction" :key="index">
          <h6 class="introduction-item-title-reward h-16 md:h-8 lg:h-10 xl:h-10 px-2 font-semibold" :class="{ hiddenReward: !item.reward }">
            <span v-if="item.reward">\</span>
            {{ item.reward }}
          </h6>
          <div class="introduction-item-content flex flex-grow pb-2">
            <div class="introduction-item-content-mag px-1 lg:px-4 w-2/5">
              <img :src="item.img_url" class="object-contain">
            </div>
            <div class="introduction-item-text w-3/5 pl-1">
              <div class="xl:flex items-center leading-loose">
                <h6 class="introduction-item-magName font-black whitespace-no-wrap">{{ item.magName }}</h6>
              </div>
              <div class="introduction-item-level mb-1 flex items-center flex-wrap">
                <p class="leading-loose">{{ item.level }}</p>
                <span class="introduction-item-span rounded-full px-2 py-1 ml-2 whitespace-no-wrap mb-1 text-sm" v-if="item.isLabel">#符合108課綱</span>
              </div>
              <p class="font-bold leading-loose">{{ item.textTitle }}</p>
              <p class="highlight leading-loose">適用程度：{{ item.degree }}</p>
              <p class="highlight leading-loose">適用族群：{{ item.peple }}</p>
              <p class="leading-loose">學習目標：{{ item.target }}</p>
            </div>
          </div>
          <div class="introduction-quote py-3 px-8 mt-3 lg:mt-0">
            <h6 class="font-bold mb-1">雜誌特色</h6>
            <p class="">專為英語初學者編訂的基礎英語學習雜誌，活潑、實用、有趣的豐富內容，學英語不再痛苦，情境教學，讓學英語像學母語般輕鬆自然。</p>
          </div>
        </div>
        <!-- 讀後心得 -->
        <div class="introduction-review w-full lg:w-1/2 p-2 py-4 md:p-4">
          <div class="pt-2 pb-4 xl:pb-6 pl-2">
            <img src="~@/assets/images/ACD18/review.png" class="object-contain">
          </div>

          <div class="introduction-review-text flex mb-2" v-for="(item, index) in review" :key="index">
            <div class="w-1/5 md:w-auto">
              <img :src="item.img_url" class="object-contain">
            </div>
            <div class="w-4/5 pl-8">
              <div class="introduction-review-quote pt-4 pb-5 px-4">
                <h6 class="font-bold mb-2 tracking-wider">{{ item.name }}</h6>
                <p class="tracking-wider">{{ item.text }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="reserve py-10 mt-4">
      <router-link :to="{ name: 'sale', params: { category: 'book' }, query: { tag: 64 } }" class="block px-4 cursor-pointer">
        <img src="~@/assets/images/ACD18/GO.png" class="object-contain mx-auto">
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ACD18',
  metaInfo () {
    return {
      title: '防疫不出門 在家學語文',
      titleTemplate: null
    }
  },
  data () {
    return {
      features: [
        { id: 5936, img_url: require('@/assets/images/ACD18/P1.jpg'), title: '❶ 全彩吸睛圖片', title2: '學習力更加倍' },
        { id: 5936, img_url: require('@/assets/images/ACD18/P2.jpg'), title: '❷ 生活必備會話', title2: '培養日常溝通能力' },
        { id: 5936, img_url: require('@/assets/images/ACD18/P3.jpg'), title: '❸ 寫作與閱讀', title2: '培養文章組織能力' },
        { id: 5936, img_url: require('@/assets/images/ACD18/P4.jpg'), title: '❹ 每月最新', title2: '焦點HOT討論話題' }
      ],
      introduction: [
        { id: 5936, img_url: require('@/assets/images/ACD18/abc.jpg'), reward: ` 10度榮獲文化部《中小學生優良課外讀物推介》/`, magName: 'ABC互動英語', level: '中級 / 生活 / 實用', isLabel: true, textTitle: '打好英語基礎的最佳選擇！', degree: '進階英語學習', peple: '國中小學生～成人，英語初學者', target: '英語能力日趨成熟，加強聽說寫作能力，相當於大學非英語主修系所畢業。', feature: '教材貼近生活、流行，實用會話輕鬆學。真人拍攝情境會話課程，開口說英語不再困難，體驗如在國外環境學英語的驚人效果。' },
        { id: 5936, img_url: require('@/assets/images/ACD18/live.jpg'), reward: '', magName: 'Live互動英語', level: '中高級 / 進階 / 應用', isLabel: false, textTitle: '日常生活實用英語輕鬆學', degree: '全民英檢中級', peple: '國高中生～成人、一般生活英語會話', target: '具備一般生活會話溝通、基本寫作、文章閱讀能力，相當於高中畢業程度。' },
        { id: 5936, img_url: require('@/assets/images/ACD18/all.jpg'), reward: '', magName: 'ALL+互動英語', level: '中高級 / 進階 / 應用', isLabel: true, textTitle: '閱讀寫作訓練豐富又多元', degree: '進階英語學習', peple: '具基礎能力，想要英語再升級的高中生～成人', target: '英語能力日趨成熟，加強聽說寫作能力，相當於大學非英語主修系所畢業。' },
        { id: 5936, img_url: require('@/assets/images/ACD18/cnn.jpg'), reward: ' 榮獲行政院新聞局金鼎獎《最佳語言學習類雜誌獎》/', magName: 'CNN互動英語', level: '新聞 / 時事 / 新知', isLabel: false, textTitle: '官方授權的專業新聞素材', degree: '專業新聞英語學習', peple: '準備出國留學或商務人士', target: '熟悉美國文化與美語口音和常用俚語，熟稔國際新聞大事，用英語社交聊天沒問題。' },
        { id: 5936, img_url: require('@/assets/images/ACD18/jp.jpg'), reward: '', magName: '互動日本語', level: '初級 / 生活 / 實用', isLabel: false, textTitle: '日籍老師主編內容實用到位', degree: '基礎～初中級', peple: '具備一般日語閱讀能力，適用JLPT測驗N5-N3檢定', target: '具備日常生活日文閱讀能力，能聽懂日常會話，基礎日語溝通沒問題。' }
      ],
      review: [
        { img_url: require('@/assets/images/ACD18/icon1.png'), name: '中和黃同學 9年級生', text: 'ABC互動英語讓我單字量突飛猛進，搭配彩圖背誦單字，更能記得住。' },
        { img_url: require('@/assets/images/ACD18/icon2.png'), name: '台中張同學 高二生', text: 'Live互動英語當課外讀物真的非常棒！搭配mp3學習，更能事半功倍。' },
        { img_url: require('@/assets/images/ACD18/icon3.png'), name: '台北陳先生 外商業務', text: '平時閱讀CNN互動英語，更能掌握老外口音，溝通起來更順暢。' }
      ]
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
  $main-dark: #fab91a;
  $main-middle: #fedc01;
  $main-light: #fcea7c;
  #ACD18 {
    .banner {
      background-color: $main-dark;
    }
    .feature {
      background-color: $main-light;
      .color-bar {
        top: 0;
        left: 0;
        background-color: $main-middle;
        height: 25px;
        @media (max-width: 640px) {
          height: 16px;
        }
      }
      .hands {
        // z-index: 99;
        // top: 0;
        // left: 50%;
        // transform: translateX(-50%);
      }
      .feature_imgs {
        margin-top: -2.5em;
        @media (max-width: 640px) {
          margin-top: -1.8em;
        }
        // @media (max-width: 426px) {
        //   margin-top: -1.8em;
        // }
        .feature_imgs-item {
          img {
            border-top: 4px solid $main-dark;
            border-left: 4px solid $main-dark;
            border-right: 4px solid $main-dark;
          }
          .feature_imgs-item-text {
            background-color: $main-dark;
          }
        }
      }
    }
    .introduction {
      .introduction-title {
        top: -3.4em;
        left: 50%;
        transform: translateX(-50%);
        max-width: 290px;
        @media (max-width: 640px) {
          top: -2.5em;
        }
      }
      .introduction-quote {
        position: relative;
        background: $main-light;
        border-radius: 20px;
        h6 {
          color: #303030;
          font-size: 18px;
          // @media (max-width: 768px) {
          //   font-size: 16px;
          // }
        }
        p {
          color: #595959;
          // font-size: 16px;
          line-height: 1.6em;
          // @media (max-width: 768px) {
          //   font-size: 16px;
          // }
        }
        &:before {
          content: "";
          position: absolute;
          z-index: -1;
          top: -20px;
          left: 0em;
          height: 35px;
          border-right: 60px solid $main-light;
          background: $main-light;
          border-bottom-right-radius: 80px 50px;
          transform: translate(0, -2px) rotate(180deg);
        }
        &:after {
          content: "";
          position: absolute;
          z-index: -1;
          top: -20px;
          left: 2.8em;
          width: 60px;
          height: 35px;
          background: #fff;
          border-bottom-right-radius: 40px 50px;
          transform: translate(-30px, -2px) rotate(180deg);
        }
      }
      .introduction-item {
        border-bottom: 2px solid #303030;
        border-style: dashed;
        &:nth-child(5) {
          border-bottom: 0px solid #303030;
          .introduction-item-content {
            flex-grow: 0 !important;
          }
          @media (max-width: 1023px) {
            border-bottom: 2px solid #303030;
          }
        }
        &:nth-child(odd) {
        border-right: 2px solid #303030;
        border-style: dashed;
          @media (max-width: 1023px) {
            border-right: none;
          }
        }
        .introduction-item-title-reward {
          color: #ff4e00;
          font-size: 16px;
        }
        .hiddenReward {
          @media (max-width: 1023px) {
            display: none;
          }
        }
        .introduction-item-content {
          .introduction-item-content-mag {
            max-width: 207px;
          }
          .introduction-item-text {
            .label {
              color: #595959;
              font-size: 18px;
              @media (max-width: 768px) {
                font-size: 16px;
              }
            }
            h6 {
              color: #303030;
              font-size: 22px;
              @media (max-width: 768px) {
                font-size: 20px;
              }
            }
            .introduction-item-level {
              p {
                color: #595959;
                // font-size: 18px;
                // @media (max-width: 768px) {
                //   font-size: 16px;
                // }
              }
              .introduction-item-span {
                color: #303030;
                background-color: #c9c9c9;
              }
            }
            .highlight {
              text-decoration: underline;
              text-underline-offset: 6px;
            }
          }
        }
      }
      .introduction-review {
        .introduction-review-quote {
          position: relative;
          background: #2f498a;
          border-radius: 20px;
          color: white;
          &:before {
            content: "";
            position: absolute;
            z-index: -1;
            top: 6px;
            left: -1em;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 15px 45px 15px;
            border-color: transparent transparent #2f498a transparent;
            transform: rotate(-100deg);
          }
          h6 {
            font-size: 18px;
            // @media (max-width: 768px) {
            //   font-size: 18px;
            // }
          }
          p {
            font-size: 16px;
            // @media (max-width: 768px) {
            //   font-size: 16px;
            // }
          }
        }
      }
    }
    .reserve {
      background-color: $main-dark;
    }
  }
</style>
